import i18next from "i18next"
import { DocumentToUpload, UploadedDocument, ErrorResponse, ErrorFn } from "models"
import { catchError, getError, http } from "services/http"

/***************************
 **** GET THE UPLOAD URL ****
 **************************/
export type GetS3UrlAnswer = {
	document_id: string
	document_upload_url: string
}

export const getS3Url = async (
	document: DocumentToUpload
): Promise<{ res: GetS3UrlAnswer } & ErrorFn> => {
	const getS3UrlErrors = (error: ErrorResponse) => {
		switch (error?.code) {
			case "DocumentNameNotAvailableException":
				return {
					code: error?.code,
					message: i18next.t("getS3Url_error_notAvailable", { ns: "form" }),
				}
			default:
				return {
					code: error?.code,
					message: i18next.t("error_default", { ns: "form" }),
				}
		}
	}
	const res = await http
		.post<GetS3UrlAnswer>("obikeapi/account/bike/document", document)
		.then((res) => res.data)
		.catch((e) => catchError(e))
	return {
		res: res as unknown as GetS3UrlAnswer,
		getError: getError(res as unknown as ErrorResponse, getS3UrlErrors),
	}
}

/***************************
 **** DELETE A DOCUMENT ****
 **************************/
export type DeleteDocumentAnswer = Record<string, never>

export const deleteDocument = async (
	document_id: string
): Promise<{ res: DeleteDocumentAnswer } & ErrorFn> => {
	const deleteDocumentErrors = (error: ErrorResponse) => {
		switch (error?.code) {
			case "InvalidArgument":
				return {
					code: error?.code,
					message: i18next.t("delete_error_invalidArgument", { ns: "form" }),
				}
			default:
				return {
					code: error?.code,
					message: i18next.t("error_default", { ns: "form" }),
				}
		}
	}
	const res = await http
		.delete<DeleteDocumentAnswer>(`obikeapi/account/bike/document?document_id=${document_id}`)
		.then((res) => res.data)
		.catch((e) => catchError(e))
	return {
		res: res as unknown as DeleteDocumentAnswer,
		getError: getError(res as unknown as ErrorResponse, deleteDocumentErrors),
	}
}

/****************************
 ** GET THE BIKE DOCUMENTS **
 ***************************/
export type GetDocumentsAnswer = UploadedDocument[]

export const getDocuments = async (
	bike_id: string
): Promise<{ res: GetDocumentsAnswer } & ErrorFn> => {
	const getDocumentsErrors = (error: ErrorResponse) => {
		switch (error?.code) {
			case "InvalidArgument":
				return {
					code: error?.code,
					message: i18next.t("getDocuments_error_invalidArgument", { ns: "form" }),
				}
			default:
				return {
					code: error?.code,
					message: i18next.t("error_default", { ns: "form" }),
				}
		}
	}
	const res = await http
		.get<GetDocumentsAnswer>(`obikeapi/account/bike/documents?bike_id=${bike_id}`)
		.then((res) => res.data)
		.catch((e) => catchError(e))
	return {
		res: res as unknown as GetDocumentsAnswer,
		getError: getError(res as unknown as ErrorResponse, getDocumentsErrors),
	}
}
